exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#puestos[data-v-4f9951d3]{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);width:450px;z-index:99999999;-webkit-box-shadow:0 1px 4px rgba(0,0,0,.3),0 0 40px rgba(0,0,0,.1);-moz-box-shadow:0 1px 4px rgba(0,0,0,.3),0 0 40px rgba(0,0,0,.1);box-shadow:0 1px 4px rgba(0,0,0,.3),0 0 40px rgba(0,0,0,.1)}#puestos .contenido[data-v-4f9951d3]{min-height:250px!important;max-height:400px!important;overflow:auto}#puestos .card-title[data-v-4f9951d3]{margin:0!important}#puestos .list-group .list-group-item[data-v-4f9951d3]{padding-top:1px!important;padding-bottom:1px!important}#puestos .list-group .list-group-item a[data-v-4f9951d3]{font-size:.784rem!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4f9951d3","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Puestos.vue
// module id = 166
// module chunks = 0